import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import imageAnnonce from "../../../../src/assets/images/imageAnnonce1.png";
import { useTranslation } from "react-i18next";

const Annonce = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Col lg={3}>
      <Row>
        <div
          style={{
            backgroundColor: "#f6F6F6",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <p style={{ color: "#0A2739", font: "Visby CF" }}>
            {t("announcement.title")}
          </p>
          <img
            src={imageAnnonce}
            alt="Image description"
            style={{
              width: "40%", // L'image occupera 100% de la largeur disponible, vous pouvez ajuster cette valeur
              maxWidth: "80px", // Limite la largeur maximale de l'image
              height: "auto", // Garde les proportions de l'image
              marginBottom: "20px", // Espacement entre l'image et le bouton
            }}
          />
          {/* Bouton */}
          <Button
            color="primary"
            style={{
              backgroundColor: "#157088B2",
              font: "Visby CF",
              borderRadius: 5,
            }}
            onClick={() => {
              navigate("/annonces/publier");
            }}
          >
            {t("announcement.button")}
          </Button>
          {/* Lien */}

          <a
            href="/annonces"
            style={{
              color: "#157088",
              textDecoration: "underline",
              marginTop: "20px",
            }}
          >
            {t("announcement.link")}
          </a>
        </div>
      </Row>
      <Row
        style={{
          marginTop: 30,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {t("announcement.ad")}
      </Row>
    </Col>
  );
};

export default Annonce;
